import React from 'react';
import { Table, Button, Modal, Form, Input, InputNumber, Select, notification, Typography, Space, List, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import request from '../../lib/request';

export default function AssociatesPage() {
  const [data, setData] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [feeModalFor, setFeeModalFor] = React.useState(null);
  const [form] = Form.useForm();
  const [feeForm] = Form.useForm();

  const fetchAssociates = () => {
    setLoading(true);
    request
      .get('/associates')
      .then((r) => r.json())
      .then((r) => r.status && setData(r.data))
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    fetchAssociates();
    request
      .get('/services')
      .then((r) => r.json())
      .then((r) => r.status && setServices(r.data));
  }, []);

  const handleCreate = () => {
    form.validateFields().then((values) => {
      request
        .post('/associates', values)
        .then((r) => r.json())
        .then((r) => {
          if (r.status) {
            notification.success({ message: 'Associate created' });
            setModalOpen(false);
            fetchAssociates();
          } else {
            notification.error({ message: r.message });
          }
        });
    });
  };

  const handleAddFee = () => {
    feeForm.validateFields().then((values) => {
      request
        .post(`/associates/${feeModalFor.id}/services`, values)
        .then((r) => r.json())
        .then((r) => {
          if (r.status) {
            notification.success({ message: 'Referral fee added' });
            setFeeModalFor(null);
            fetchAssociates();
          } else {
            notification.error({ message: r.message });
          }
        });
    });
  };

  const columns = [
    { title: 'Name', dataIndex: 'name' },
    { title: 'Jurisdiction', dataIndex: 'jurisdiction' },
    { title: 'Contact', dataIndex: 'contact_email' },
    {
      title: '',
      key: 'actions',
      render: (_, record) => (
        <Button size="small" icon={<PlusOutlined />} onClick={() => setFeeModalFor(record)}>
          Add Referral Fee
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Associates
        </Typography.Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            form.resetFields();
            setModalOpen(true);
          }}
        >
          New Associate
        </Button>
      </Space>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        expandable={{
          expandedRowRender: (record) => (
            <List
              size="small"
              header={<strong>Referral Fees per Service</strong>}
              dataSource={record.AssociateServices || []}
              renderItem={(row) => (
                <List.Item>
                  <Tag>{services.find((s) => s.id === row.service_id)?.service_name || row.service_id}</Tag>
                  {row.referral_fee_percent}%
                </List.Item>
              )}
            />
          ),
        }}
      />

      <Modal title="New Associate" open={modalOpen} onCancel={() => setModalOpen(false)} onOk={handleCreate}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="jurisdiction" label="Jurisdiction">
            <Input />
          </Form.Item>
          <Form.Item name="tin" label="TIN">
            <Input />
          </Form.Item>
          <Form.Item name="vat_number" label="VAT Number">
            <Input />
          </Form.Item>
          <Form.Item name="contact_name" label="Contact Name">
            <Input />
          </Form.Item>
          <Form.Item name="contact_email" label="Contact Email">
            <Input />
          </Form.Item>
          <Form.Item name="commercial_terms" label="Commercial Terms">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={`Add Referral Fee — ${feeModalFor?.name || ''}`}
        open={!!feeModalFor}
        onCancel={() => setFeeModalFor(null)}
        onOk={handleAddFee}
      >
        <Form form={feeForm} layout="vertical">
          <Form.Item name="service_id" label="Service" rules={[{ required: true }]}>
            <Select options={services.map((s) => ({ value: s.id, label: s.service_name }))} />
          </Form.Item>
          <Form.Item name="referral_fee_percent" label="Referral Fee %" rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} min={0} max={100} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
